import { IFlow } from '../../telegram-bots/flows/interfaces';
import axios from '../axios';

export const deleteFlow = async (flowId: IFlow['_id']) => {
  const { data } = await axios.delete(`/flows/${flowId}`);

  return data;
};
